import React from "react";
import { get } from "lodash";
import { usDateFormat } from "../../../../utils";
import { EmployeeClassificationTable } from "./EmployeeClassificationTable";
import AddToolTip from "../../../../components/AddToolTip";

const EmployeeClassificationSliderTable = ({ data }) => {
  const employeeClassification = get(data, "employeeClassificationHistory", []);

  return (
    <div className="employee-slider-table">
      <div className="plan-sub-heading">Employee Classification</div>
      <div className="header-details">
        <div className="label">Classification type</div>
        <div className="value">{get(data, "classificationTypeName", "")}</div>
      </div>
      <div className="d-flex mt-10">
        <div className="header-details">
          <div className="label">Classification code</div>
          <div className="value">
            {get(data, "code", "")?.length > 30 ? (
              <AddToolTip
                className="short-desc"
                name={get(data, "code", "") || "-"}
                placement="bottom"
              >
                {get(data, "code", "").slice(0, 30)}...
              </AddToolTip>
            ) : (
              get(data, "code", "") || "-"
            )}
          </div>
        </div>
        <div className="header-details">
          <div className="label">Classification name</div>
          <div className="value">{get(data, "classificationName", "")}</div>
        </div>
        <div className="header-details">
          <div className="label">Start date</div>
          <div className="value">
            {usDateFormat(get(data, "effectiveStartDate", ""))}
          </div>
        </div>
        <div className="header-details">
          <div className="label">End date</div>
          <div className="value">
            {usDateFormat(get(data, "effectiveEndDate", ""))}
          </div>
        </div>
      </div>
      <div className="line-separator" />

      <EmployeeClassificationTable data={employeeClassification} />
    </div>
  );
};

export default EmployeeClassificationSliderTable;
